// Org-locations admin types — shared between the client wrapper, the
// hook, and the section components. Mirrors the server's
// `OrgLocationRow` (server/org-domain/locationsRepo.ts) but keeps the
// LocationType union narrowed for UI-side dropdowns / icons / chips.
export const LOCATION_TYPE_VALUES = [
  "retail",
  "plant",
  "corporate",
  "virtual",
] as const;
export type OrgLocationType = (typeof LOCATION_TYPE_VALUES)[number];

export type OrgLocation = {
  id: string;
  organization_id: string;
  name: string;
  location_code: string | null;
  location_type: OrgLocationType | string | null;
  address_1: string | null;
  address_2: string | null;
  city: string | null;
  state: string | null;
  postal_code: string | null;
  country: string | null;
  phone: string | null;
  email: string | null;
  notes: string | null;
  is_active: boolean;
  is_public: boolean;
  created_at: string;
  updated_at: string;
};

export type OrgLocationDraft = {
  name?: string;
  location_code?: string | null;
  location_type?: OrgLocationType | null;
  address_1?: string | null;
  address_2?: string | null;
  city?: string | null;
  state?: string | null;
  postal_code?: string | null;
  country?: string | null;
  phone?: string | null;
  email?: string | null;
  notes?: string | null;
  is_active?: boolean;
  is_public?: boolean;
};
